import { supabase } from '@/integrations/supabase/client';

export interface VideoRecord {
  id: string;
  user_id: string;
  mux_asset_id?: string | null;
  mux_playback_id?: string | null;
  playback_policy?: string | null;
  status: string;
  duration?: number | null;
  width?: number | null;
  height?: number | null;
  created_at: string;
  updated_at?: string | null;
  deleted_at?: string | null;
}

export async function listMyVideos(limit = 50): Promise<{ data: VideoRecord[] | null, error: any }> {
  const { data: { user }, error: authError } = await supabase.auth.getUser();
  
  if (authError || !user) {
    return { data: null, error: authError || new Error('Not authenticated') };
  }

  return supabase
    .from('videos')
    .select('*')
    .eq('user_id', user.id)
    .eq('status', 'ready')           // Filter by ready status instead of non-existent playback_url_ready
    .not('mux_playback_id', 'is', null)  // Ensure playback ID exists
    .is('deleted_at', null)          // Exclude soft-deleted videos
    .order('updated_at', { ascending: false })  // Order by updated_at instead of non-existent ready_at
    .limit(limit);
}

export async function getVideoById(id: string): Promise<{ data: VideoRecord | null, error: any }> {
  const { data: { user }, error: authError } = await supabase.auth.getUser();
  
  if (authError || !user) {
    return { data: null, error: authError || new Error('Not authenticated') };
  }

  const { data, error } = await supabase
    .from('videos')
    .select('*')
    .eq('id', id)
    .eq('user_id', user.id)
    .single();

  return { data, error };
}